import React, { ReactNode } from 'react';
import Table, { TableProps } from 'antd/lib/table';
import { ColumnFilterItem, FilterDropdownProps } from 'antd/lib/table/interface';
import { TableRecord } from '@utils/types';
import { Container } from './styles';
import { sorter } from './sorter';

export interface TableRow {
  id: string;
  column1: ReactNode;
  column2: ReactNode;
  column3?: ReactNode;
  column4?: ReactNode;
}

export interface TableColumn {
  title: string;
  dataIndex: string;
  width?: string;
  render?: never;
  filters?: ColumnFilterItem[];
  onFilter?: (value: string | number | boolean, record: TableRecord) => boolean;
  filterDropdown?: React.ReactNode | ((props: FilterDropdownProps) => React.ReactNode);
  filterIcon?: React.ReactNode | ((filtered: boolean) => React.ReactNode);
  sorter?: ReturnType<typeof sorter>;
}

interface Props<T> extends TableProps<T> {
  readOnly?: boolean;
  version?: 1 | 2;
}

export default <T extends object>({
  columns,
  readOnly = false,
  version = 1,
  ...props
}: Props<T>) => (
  <Container readOnly={readOnly} version={version}>
    <Table
      id="members-table"
      rowKey="id"
      columns={columns}
      {...props}
      getPopupContainer={() => document.getElementById('members-table')!}
    />
  </Container>
);
